import React, { useState } from 'react';
import Spinner from '../Spinner';
import { toast } from 'react-toastify';
import axios from "axios";

const SubscriptionForm = ({info}) => {
  const [submitInfo, setSubmitInfo] = useState(info || {
    clientName: '',
    customerFirstName: '',
    customerLastName: '',
    customerEmail: '',
    password: '',
    confirmPassword: '',
    quantity: 1,
    title: '',
    subscriptionType: 'MONTHLY'
  });

  const [instanceCreationStatus, setInstanceCreationStatus] = useState("STARTED");
  const [instanceCreated, setInstanceCreated] = useState(false);
  const [isInstanceError, setIsInstanceError] = useState(false);
  const [username, setUsername] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [verifyInformation, setVerifyInformation] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isPasswordInvalid , setIsPasswordInvalid] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;

    setSubmitInfo({
      ...submitInfo,
      [name]: value,
    }); 

    if (name === 'customerFirstName' || name === 'customerLastName') {
      const firstName = name === 'customerFirstName' ? value : submitInfo.customerFirstName;
      const lastName = name === 'customerLastName' ? value : submitInfo.customerLastName;

      const formattedUserName = firstName.replace(/\s/g, '') + '.' + lastName.replace(/\s/g, '');
      setUsername(formattedUserName);
    }

  }

  const validatePassword = (formInfo) => {
    let isValid = true,
				password = formInfo.password || '',
        confirmPassword = formInfo.confirmPassword || '',
				charTypeCount = 0;
			// Validation: requirements
			if (password != confirmPassword) {
        toast('The two passwords you entered do not match.', {
          autoClose: 6000,
          type: toast.TYPE.ERROR,
        });
				isValid = false;
			}
			if ((isValid && password.length < 8) || password.length > 255) {
        toast('Your password must be between 8 and 255 characters long.', {
          autoClose: 6000,
          type: toast.TYPE.WARNING,
        });
				isValid = false;
			}
			if (password.match(/\d/)) {
				charTypeCount += 1;
			}
			if (password.match(/[a-z]/)) {
				charTypeCount += 1;
			}
			if (password.match(/[A-Z]/)) {
				charTypeCount += 1;
			}
			if (password.match(/[!@#$%^&*()]/)) {
				charTypeCount += 1;
			}

			// Validation: violations
			if (isValid && charTypeCount < 4) {
        toast('Your password needs at least three of a lowercase letter, uppercase letter, number and a symbol.', {
          autoClose: 6000,
          type: toast.TYPE.ERROR,
        });
				isValid = false;
			}

			return isValid;
  }


  const verifySubmitInfo = (info) => {
    if(!info.clientName || !info.customerFirstName || !info.customerLastName || !info.customerEmail || !info.title) {
      toast('Please fill all the required info', {
        autoClose: 6000,
        type: toast.TYPE.WARNING,
      });
      return false;
    }
    if(!/\S+@\S+\.\S+/.test(info.customerEmail)) {
      toast('Please a valid email', {
        autoClose: 6000,
        type: toast.TYPE.WARNING,
      });
      return false;
    }

    if(!validatePassword(info)) {
      setIsPasswordInvalid(true);
      return false;
    }
    return true;
  }

  const checkInstanceStatus = (instanceId) => {
    axios.get(`/subscription/v1/instance-creation-status/${instanceId}`)
    .then(instanceRes => {
      const step = instanceRes.data.instanceCreationStep;
      setInstanceCreationStatus(step);
      if(step === 'COMPLETED') {
        window.open(instanceRes.data.instanceLink, '_blank');
        setInstanceCreated(true);
      } else if(step === 'ERROR') {
        setIsInstanceError(true);
        toast('There was an error creating your instance. Please contact support.', {
          autoClose: 6000,
          type: toast.TYPE.ERROR,
        });
      } else{
        setTimeout(() => checkInstanceStatus(instanceId), 5000);
      }
    })
  }


  const handleSubmit = () => {
    if(!verifyInformation || !isAgreed) {
      toast('Please verify the information and agree the user agreements', {
        autoClose: 6000,
        type: toast.TYPE.WARNING,
      });
      return;
    }

    if(!verifySubmitInfo(submitInfo)) {
      return;
    }

    setIsLoading(true);

    axios.post(`/subscription/v1/create-instance-with-verification`, submitInfo)
    .then((res) => {
      setFormSubmitted(true);
      checkInstanceStatus(res.data.id);
    }).catch((err) => {
      toast(err.response.data.error, {
        autoClose: 6000,
        type: toast.TYPE.ERROR,
      });
    })
    .finally(() => {
      setIsLoading(false);
    })
  }

  const InstanceStatus = ({isInstanceError, instanceCreated, instanceCreationStatus}) => {
    if (isInstanceError) {
      return <p className="text-white leading-8 text-center">There was an error creating your instance. Please contact support.</p>;
    }
    if (!instanceCreated) {
      return (
        <>
          <p className="text-white leading-8 text-center">
            Your instance is being created, please wait until the process is completed. You will be redirected.
          </p>
          <Spinner />
        </>
      );
    }
    return (
      <p className="text-white leading-8 text-center">
        Your instance has been created successfully! A new tab will be open. Please check that the browser popup blocker is disabled for this site.
      </p>
    );
  }

  return (
     <>
      {!formSubmitted && (
        <>
        <div className="grid grid-cols-1 gap-4 justify-items-center mb-3">
          <span className="text-white font-bold text-xl sm:text-sm">Sign up to get started for free!</span>
        </div>
        <div className="grid grid-cols-1 gap-1 mb-5 px-2">
          <span className=" text-white font-light text-sm">Company Name</span>
          <input
            name="clientName"
            value={submitInfo.clientName}
            onChange={handleChange}
            type="text"
            className="bg-D9D9D9 block w-full rounded-[12px] border-gray-300 shadow-sm focus:border-ETWOrange focus:ring-ETWOrange sm:text-sm"
            ></input>
        </div>
        <div className="grid grid-cols-1 gap-1 mb-5 px-2">
          <span className=" text-white font-light text-sm">First Name</span>
          <input
            value={submitInfo.customerFirstName}
            onChange={handleChange}
            type="text"
            name="customerFirstName"
            className="bg-D9D9D9 block w-full rounded-[12px] border-gray-300 shadow-sm focus:border-ETWOrange focus:ring-ETWOrange sm:text-sm"
            ></input>
        </div>

        <div className="grid grid-cols-1 gap-1 mb-5 px-2">
          <span className=" text-white font-light text-sm">Last Name</span>
          <input
            value={submitInfo.customerLastName}
            onChange={handleChange}
            type="text"
            name="customerLastName"
            className="bg-D9D9D9 block w-full rounded-[12px] border-gray-300 shadow-sm focus:border-ETWOrange focus:ring-ETWOrange sm:text-sm"
            ></input>
        </div>

        <div className="grid grid-cols-1 gap-1 mb-5 px-2">
          <span className=" text-white font-light text-sm">Title</span>
          <input
            value={submitInfo.title}
            onChange={handleChange}
            type="text"
            name="title"
            className="bg-D9D9D9 block w-full rounded-[12px] border-gray-300 shadow-sm focus:border-ETWOrange focus:ring-ETWOrange sm:text-sm"
            ></input>
        </div>

        <div className="grid grid-cols-1 gap-1 mb-5 px-2">
          <span className=" text-white font-light text-sm">Username</span>
          <input
            value={username}
            type="text"
            name="username"
            disabled
            className="bg-D9D9D9 block w-full rounded-[12px] border-gray-300 shadow-sm focus:border-ETWOrange focus:ring-ETWOrange sm:text-sm"
            ></input>
        </div>

        <div className="grid grid-cols-1 gap-1 mb-5 px-2">
          <span className=" text-white font-light text-sm">Password</span>
          <input
            value={submitInfo.password}
            onChange={handleChange}
            type="password"
            name="password"
            className={`bg-D9D9D9 block w-full rounded-[12px] border-gray-300 shadow-sm focus:ring-ETWOrange sm:text-sm ${
                      isPasswordInvalid === true ? 'border-red-500 focus:ring-red-500' : 'focus:border-ETWOrange focus:ring-ETWOrange'
                    }`}
            ></input>
        </div>

        <div className="grid grid-cols-1 gap-1 mb-5 px-2">
          <span className=" text-white font-light text-sm">Confirm Password</span>
          <input
            value={submitInfo.confirmPassword}
            onChange={handleChange}
            type="password"
            name="confirmPassword"
            className={`bg-D9D9D9 block w-full rounded-[12px] border-gray-300 shadow-sm focus:ring-ETWOrange sm:text-sm ${
                      isPasswordInvalid === true ? 'border-red-500 focus:ring-red-500' : 'focus:border-ETWOrange focus:ring-ETWOrange'
                    }`}
            ></input>
        </div>

        <div className="grid grid-cols-1 gap-1 mb-5 px-2">
          <span className=" text-white font-light text-sm">Email</span>
          <input
            value={submitInfo.customerEmail}
            onChange={handleChange}
            type="text"
            name="customerEmail"
            disabled
            className="bg-D9D9D9 block w-full rounded-[12px] border-gray-300 shadow-sm focus:border-ETWOrange focus:ring-ETWOrange sm:text-sm"
            ></input>
        </div>

        <div className="grid grid-cols-1 gap-1 mb-5 px-2">
            <label>
              <input
                checked={verifyInformation}
                onChange={(e) => {
                  setVerifyInformation(!verifyInformation);
                }}
                id="checkbox_verify"
                type="checkbox"
                className="border-white bg-254C5A text-254C5A focus:ring-0 h-4 w-4 rounded-sm shadow-sm focus:border-blue-500 focus:ring-blue-500"
                ></input>
                <span className=" text-white font-light text-base ml-1">I verify that the information above is correct</span>
            </label>
        
        </div>

        <div className="grid grid-cols-1 gap-1 mb-5 px-2">
          <label>
            <input
              checked={isAgreed}
              onChange={(e) => {
                setIsAgreed(!isAgreed);
              }}
              id="checkbox_agreement"
              type="checkbox"
              className="border-white bg-254C5A text-254C5A focus:ring-0 h-4 w-4 rounded-sm shadow-sm focus:border-blue-500 focus:ring-blue-500"
              ></input>
              <span className=" text-white font-light text-base ml-1">I have read and understand the </span>
              <a className="text-white italic underline" href="https://www.etw.com/user-agreement" target="blank">User Agreement</a>
          </label>
        </div>
        <div className="grid grid-cols-1 gap-1 mb-5 px-2 justify-items-center ">
          <button onClick={handleSubmit} className="bg-8A8988 text-white font-bold text-base rounded-[12px] h-10 w-1/2 hover:bg-ETWOrange disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-500 disabled:shadow-none dark:disabled:border-gray-700 dark:disabled:bg-gray-800/20 " disabled={isLoading}>
            {isLoading ? <Spinner /> : 'Sign Up'}
          </button>
        </div>
        </>
      )}
      {formSubmitted && (<>
        <div className="grid grid-cols-1 gap-4 justify-items-center mb-3 mt-10">
          <span className="text-white font-bold text-2xl">You are almost in!</span>
        </div>
        <div className="grid grid-cols-1 gap-4 justify-items-center mb-3 px-10">

          <InstanceStatus
            isInstanceError={isInstanceError}
            instanceCreated={instanceCreated}
            instanceCreationStatus={instanceCreationStatus}
          />
          
          <p className="text-white leading-8 text-center "> {instanceCreationStatus}
          </p>
        </div>
      </>)}
     </>
  );
};

export default SubscriptionForm;